import React from 'react';
import { useField, ErrorMessage} from 'formik';
import { InputAdornment, TextField, InputLabel } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';


interface Props {
  name: string;
  inputLabel: string;
  className: string
}

const TextfieldWrapper: React.FC<Props> = ({
  inputLabel,
  name,
  ...otherProps
}) => {
  const [field, meta] = useField(name);

  const configTextfield: any = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: 'outlined'
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
  
  }

  return (
    <>  <InputLabel htmlFor="grouped-native-select"
      className={
        meta && meta.touched && meta.error ? "error-color vehicleDropdownlabel" : "vehicleDropdownlabel"
      }
    >
      {inputLabel} <span style={{color:'red'}}>*</span></InputLabel>
      <TextField  
            sx={{
              "& .MuiOutlinedInput-root.Mui-focused": {
                "& > fieldset": {
                  borderColor: "#c4c4c4"
                }
              }
            }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {
              meta.touched && meta.error && (
                <ErrorIcon
                sx={{
                  position: "absolute",
                  right: "12px",
                  height: "24px",
                  width: "24px",
                  color: "#DC3545",
                  fontSize: "large"
                 
                }}
                />
              )
            }
          </InputAdornment>
        )
      }}
        {...configTextfield} />
               <ErrorMessage component='p' name={name} className = "select-error error-color fs-14"/>

    </>
  );
};

export default TextfieldWrapper;
